import SharedFilters from './SharedFilters';

export default SharedFilters;
